import React from 'react'
import OurServicesMain from './OurServicesMain'
import DotedPart from '../common/DotedPart'

const IndexOurServices = () => {
    return (
        <>
            <OurServicesMain />
            <DotedPart className="mt-[40px] md:mt-[-10px] mb-[50px] md:mb-[89px]" />
        </>
    )
}

export default IndexOurServices